import Plyr from 'plyr';
import Tools from './../components/tools';
import gsap from 'gsap';

export default class Home {
    constructor() {
        // Home
        const containers = document.querySelectorAll('.accordeon');
        if (containers.length > 0) {
            containers.forEach((container) => {
                this.accordeons(container);
            });
        }

        this.header();
        this.videos();
        this.references();
        this.bureau();
        this.logo();
        if (window.innerWidth > 1023) {
            this.slides();
        }
        this.anchors();
        this.scrollingNav();
    }

    header() {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
        if (isSafari) {
            document.querySelector('.header__image--video').style.display = 'none';
            document.querySelector('.header__image--fallback').style.display = 'block';
        }
    }

    accordeons(container) {
        const elts = container.querySelectorAll('.accordeon__item');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                elt.querySelector('.accordeon__close').addEventListener('click', () => {
                    elt.classList.toggle('js-open');

                    if (elt.classList.contains('js-open')) {
                        Tools.fixedToAuto(elt.querySelector('.accordeon__content'));
                    } else {
                        Tools.autoToFixed(elt.querySelector('.accordeon__content'));
                    }
                });
            });
        }
    }

    videos() {
        const elts = document.querySelectorAll('.video__player');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                // https://github.com/sampotts/plyr/blob/master/CONTROLS.md
                const controls = `<div class="plyr__controls">
                    <div class="plyr__progress">
                        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
                        <span role="tooltip" class="plyr__tooltip">00:00</span>
                    </div>
                </div>
                <button type="button" class="plyr__control plyr__control--overlaid" data-plyr="play" aria-pressed="false" aria-label="Play, the IA video">
                    <svg aria-hidden="true" focusable="false">
                        <use xlink:href="#plyr-play"></use>
                    </svg>
                    <span class="plyr__sr-only">Play</span>
                </button>`;

                const player = new Plyr(elt, { controls });

                if (player && elt.dataset.poster) {
                    setTimeout(() => {
                        player.poster = elt.dataset.poster;
                    }, 200);
                }

                if (elt.nextElementSibling.classList.contains('cta')) {
                    elt.nextElementSibling.addEventListener('click', (e) => {
                        player.play();
                    });
                }
            });
        }
    }

    references() {
        const elts = document.querySelectorAll('.reference .reference__item');
        if (elts.length > 0) {
            elts.forEach((elt, index) => {
                let orientation = 100;
                if (index % 2 == 0) {
                    orientation = -100;
                }
                const animation = gsap.to(
                    elt.querySelectorAll('.reference__slider'),
                    {
                        xPercent: orientation,
                        ease: 'linear',
                        duration: 20,
                        repeat: -1,
                        overwrite: 'auto',
                    }
                );

                // window.addEventListener('scroll', () => {
                //     animation.timeScale(1 + Math.abs(window.scrollInstance.velocity) / 10);
                // });
            });
        }

        // TODO : Supprimer quand contenu dynamisé
        const content = document.querySelector('.reference__content .textContainer');
        if (content) {
            content.querySelectorAll('p').forEach((p) => {
                p.setAttribute('data-text', p.innerText);
            });
        }
    }

    bureau() {
        const container = document.querySelector('.etude__images');
        if (container) {
            container.querySelectorAll('.images__container').forEach((elt) => {
                let largeur = 0;
                elt.querySelectorAll('.images__item').forEach((img, index) => {
                    if(index === 0) {
                        largeur += img.offsetWidth;
                    } else {
                        largeur += img.offsetWidth + 16;
                    }
                });
                elt.style.width = `${largeur}px`;
            });

            if(container.querySelectorAll('.images')[0]) {
                gsap.to(container.querySelectorAll('.images')[0].children[0], {
                    xPercent: -100, 
                    ease: 'none',
                    scrollTrigger: {
                        trigger: container.querySelectorAll('.images')[0],
                        start: 'top bottom',
                        scrub: true,
                        end: `+=${window.innerHeight}`
                    }
                });
            }

            if(container.querySelectorAll('.images')[1]) {
                gsap.to(container.querySelectorAll('.images')[1].children[0], {
                    xPercent: 100, 
                    ease: 'none',
                    scrollTrigger: {
                        trigger: container.querySelectorAll('.images')[1],
                        start: 'top bottom',
                        scrub: true,
                        end: `+=${window.innerHeight}`
                    }
                });
            }
        }
    }

    slides() {
        const sections = gsap.utils.toArray('.section .etude, .section .studio, .section .operation');
        if (sections.length > 0) {
            sections.forEach((section) => {
                gsap.to(section, {
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: 'bottom bottom',
                        pinSpacing: false,
                        pin: true,
                        scrub: true,
                        end: `+=${window.innerHeight}`
                    }
                });
            });
        }
    }

    anchors() {
        const elts = document.querySelectorAll('.menu__link');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (document.querySelector(`#${this.getLocaleFromHash(elt.href)}`)) {
                        window.scrollTo({
                            top: Tools.offset(document.querySelector(`#${this.getLocaleFromHash(elt.href)}`)).top,
                            left: 0,
                            behavior: 'smooth',
                        });

                        if (window.innerWidth < 1024) {
                            document.querySelector('.nav__content').classList.remove('js-open');
                            document.querySelector('.nav__burger').classList.remove('js-open');
                        }
                    }
                });
            });
        }
    }

    getLocaleFromHash(str) {
        const regex = /#([a-zA-Z0-9-_]+)$/gi;
        let m;
        while ((m = regex.exec(str)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            return m[1];
        }
    }

    scrollingNav() {
        const elts = document.querySelectorAll('#laboratoire-de-son, #bureau-detude, #studio-immersif, #service, #references');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                // console.log(elt.id, Tools.offset(elt).top - 1, Tools.offset(elt).top + elt.offsetHeight - 1);
                window.addEventListener('scroll', () => {
                    if (window.pageYOffset > (Tools.offset(elt).top - 1) && window.pageYOffset < (Tools.offset(elt).top + elt.offsetHeight - 1)) {
                        if (document.querySelector(`.nav .menu__item.js-active`)) {
                            document.querySelector(`.nav .menu__item.js-active`).classList.remove('js-active');
                        }
                        if (document.querySelector(`.nav .menu__item[data-id="${elt.id}"]`) && !document.querySelector(`.nav .menu__item[data-id="${elt.id}"]`).classList.contains('js-active')) {
                            document.querySelector(`.nav .menu__item[data-id="${elt.id}"]`).classList.add('js-active');
                        }
                    } else {
                        if (document.querySelector(`.nav .menu__item[data-id="${elt.id}"]`)) {
                            document.querySelector(`.nav .menu__item[data-id="${elt.id}"]`).classList.remove('js-active');
                        }
                    }
                });
            });
        }
    }

    logo() {
        const btn = document.querySelector('.nav__logo');
        if (btn) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            });
        }
    }
}